import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { InspectionModel } from '../models/inspection.model';

@Injectable()
export class InspectionSourceService {
  inspectionSource: MatTableDataSource<InspectionModel>;

  setInspectionsSource(inspectionSource: MatTableDataSource<InspectionModel>) {
    if (this.inspectionSource) {
      this.inspectionSource.disconnect();
    }
    this.inspectionSource = inspectionSource;
  }

  disconnect() {
    if (this.inspectionSource) {
      this.inspectionSource.disconnect();
      this.inspectionSource = null;
    }
  }
}
